{
  "cta": {
    "create-a-chart": "チャートを作成"
  },
  "breadcrumb": {
    "dashboard": "ダッシュボード",
    "products": "商品",
    "charts": "チャート",
    "restock-alerts": "再入荷アラート",
    "settings": "設定",
    "setting": "設定",
    "account": "アカウント",
    "personal": "個人情報",
    "organization": "組織",
    "appearance": "外観",
    "themes": "テーマ",
    "button": "ボタン",
    "font-family": "フォントファミリー",
    "uploads": "アップロード",
    "dimensions": "寸法",
    "notifications": "通知",
    "analytic": "分析",
    "analytics": "分析",
    "restock-settings": "再入荷設定",
    "inventory": "再入荷アラート",
    "plans": "プラン",
    "billing": "請求",
    "overview": "概要",
    "plan-and-usage": "プランと利用状況",
    "chart-views": "チャート閲覧数",
    "add-to-cart": "カートに追加",
    "buy-now": "今すぐ購入",
    "size-recommendations": "サイズ推奨",
    "stock-notifications": "在庫通知",
    "reports": "レポート",
    "comparison": "比較",
    "images": "アップロード",
    "sidekick": "サイドキック",
    "import": "インポート",
    "contact": "お問い合わせ",
    "help-articles": "ヘルプ記事",
    "new": "新規"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "テーブル形式チャート",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "すべての行、列、測定単位を完全に制御できる、完全カスタムのグリッドを作成します。複数の地域にまたがる複雑なサイズ展開に最適です。",
      "create-table-chart": "テーブルチャートを作成",
      "create-from-product": "商品から作成",
      "start-from-template": "テンプレートから開始",
      "browse-templates": "テンプレートを見る",
      "create-with-drag-drop": "ドラッグ&ドロップで作成",
      "creating": "作成中",
      "how-would-you-like-to-build-your-chart": "どのように<br /><span class=\"text-primary\">チャートを作成しますか?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "以下から方法を選択するか、何を販売しているか教えていただければ、最適な方法をご案内します。",
      "fastest-setup-2-min": "最速セットアップ · 約2分",
      "used-by-1000-merchants": "1000以上の店舗で利用中",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "既存のShopifyバリアントデータから直接一致するサイズチャートを自動生成します。手入力は不要 — 商品情報を読み取り、自動でテーブルを埋めます",
      "garment-templates-ready-to-use": "すぐに使える衣料テンプレート",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "トップス、ボトムス、シューズ、ベルト、バッグなどの既製テンプレートから選択できます。後から各項目を自由にカスタマイズでき、1分足らずで始められます。",
      "drag-drop-no-data-needed-upfront": "ドラッグ&ドロップ · 事前のデータ入力不要",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "任意の商品画像をアップロードし、ドラッグ&ドロップのピンで直接寸法を記入できます。シューズ、バッグ、アクセサリー、器具に最適です。",
      "excel-like": "Excelライク",
      "auto-generated": "自動生成",
      "annotate-on-image": "画像上に記入",
      "what-are-you-selling": "何を販売していますか?",
      "category-clothing-apparel": "衣料品・アパレル",
      "category-shoes": "シューズ",
      "category-accessories": "アクセサリー",
      "category-other": "その他",
      "start-date": "開始日",
      "end-date": "終了日"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "商品を選択して、その商品用のサイズチャートを作成またはリンクします。",
      "product-name": "商品名",
      "best-selling": "売れ筋",
      "most-selling": "販売数の多い順",
      "least-selling": "販売数の少ない順",
      "best-selling-unavailable": "販売データがまだないため、商品は最終更新順に表示されています。",
      "chart-attached": "チャート添付済み",
      "shopify-status": "Shopifyステータス",
      "search-placeholder": "全商品を検索...",
      "vendors": "仕入先",
      "tags": "タグ",
      "statuses": "ステータス",
      "collections": "コレクション",
      "types": "タイプ",
      "add-filter": "フィルターを追加",
      "categories": "カテゴリー",
      "search-and-filter-tooltip": "検索とフィルター (F)",
      "import-selection": "選択項目をインポート",
      "failed-import-measurements": "寸法のインポートに失敗しました",
      "product-updated": "商品を正常に更新しました"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "ここからチャートの作成、編集、複製、または商品へのリンクができます。",
      "chart-name": "チャート名",
      "chart-type": "チャートタイプ",
      "linked-to": "リンク先",
      "last-updated": "最終更新日",
      "delete-x-charts": "{{ x }} 件のチャートを削除",
      "assigned-products": "割り当て済み商品",
      "failed-to-fetch-products-data": "商品データの取得に失敗しました",
      "delete-chart": "チャートを削除",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "選択したチャートを削除してもよろしいですか?このチャートを使用しているすべての商品の割り当てが解除されます。",
      "successfully-deleted-chart-s": "チャートを正常に削除しました!",
      "successfully-duplicated-chart": "チャートを正常に複製しました!",
      "turn-this-into-a-conversion-chart": "コンバージョンチャートに変換",
      "upgradable-tooltip": "このテーブルチャートは構造化されたサイズチャートに似ており、変換できます。",
      "convert-to-size-chart": "サイズチャートに変換",
      "convertibility-failed": "変換可能なテーブルチャートを確認できませんでした。",
      "convert": {
        "table-chart-info-callout": "このテーブルチャートはスマートサイズチャートにアップグレードできます",
        "table-chart-info-callout-message": "変換すると、グリッドがライブラリの寸法にマッピングされ、通常のテーブルでは表示できない視覚的な採寸ガイドとモデル情報が利用可能になります。",
        "successfully-converted": "サイズチャートへの変換が完了しました!",
        "detected-sizes": "検出されたサイズ",
        "at-least-two-sizes-are-needed": "このチャートを変換するには、少なくとも2つのサイズが必要です。",
        "unnamed-row": "名称未設定の行",
        "ignore-this-row": "この行を無視",
        "this-dimension-is-already-mapped": "この寸法はすでに別の行にマッピングされています。",
        "map-at-least-one-row": "少なくとも1つの行を寸法にマッピングしてください。",
        "finish-your-measurement-guide": "採寸ガイドを完成させる",
        "measurement-points-without-values": "値のない採寸ポイント ({{ x }})",
        "fill-them-in-after-converting": "選択した画像には表示されていますが、テーブルにはこれらの行がありませんでした。変換後に値を入力してください。",
        "measurements-without-points": "画像上にポイントのない寸法 ({{ x }})",
        "no-image-selected-yet": "まだ画像が選択されていません",
        "upload-an-image-then-drag-points": "画像をアップロードし、採寸ポイントをその上にドラッグしてください。",
        "your-image-has-no-measurement-points": "選択した画像にはまだ採寸ポイントがありません",
        "drag-measurement-points-onto-the-image": "採寸ポイントを画像上にドラッグして、購入者がどこを測るべきか分かるようにしてください。",
        "plus-x-more": "他 {{ x }} 件",
        "satisfied-button": "問題なさそうです — これをライブチャートにする",
        "satisfied-explanation": "テーブルチャートは非公開になり、このチャートが公開され、割り当てられた商品が移行されます。",
        "satisfied-success": "このチャートが公開されました!",
        "step-x-of-y": "ステップ {{ x }} / {{ y }}",
        "choose-product-type": "商品タイプを選択",
        "well-match-your-table-to-a-visual": "テーブルを適切なビジュアル商品にマッチングします。",
        "save-settings": "設定を保存",
        "review-table-mapping": "テーブルマッピングを確認",
        "confirm-the-rows-to-convert": "変換する行を確認してください。",
        "existing-table": "既存のテーブル",
        "sizes": "サイズ",
        "row": "行",
        "column": "列",
        "x-rows-need-review": "{{ x }} 件の行に確認が必要です",
        "couldnt-match-this-row": "この寸法を自動的にマッチングできませんでした",
        "change-match": "マッチングを変更",
        "view-values": "値を表示",
        "hide-values": "値を非表示",
        "matched-automatically": "自動マッチング済み",
        "edit-matches": "マッチングを編集",
        "create-preview": "プレビューを作成",
        "preview-ready": "プレビュー準備完了",
        "open-it-to-finish-the-missing-values": "開いて不足している値を入力してください。",
        "converted": "変換済み",
        "open-preview": "プレビューを開く",
        "you-can-add-them-in-the-preview": "プレビューで追加できます。"
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "メールアドレスを収集し、再入荷時に自動通知を送信します。通知を設定",
      "here": "こちら",
      "successfully-export-inventory-data": "在庫データのエクスポートに成功しました",
      "active-your-store-inventory-notification-feature": "店舗の在庫通知機能を有効にする",
      "in-order-to-receive-users-subscribed-for-your-products": "商品を登録したユーザーを受け取るために。",
      "your-subscribers-have-been-delegeted-to-your": "登録者は次に移管されました:"
    },
    "setting": {
      "storefront-popup-preview": "ストアフロントポップアップのプレビュー",
      "add-to-cart": "カートに追加",
      "buy-now": "今すぐ購入",
      "sans-serif": "サンセリフ",
      "serif": "セリフ",
      "email-body-is-required": "メール本文は必須です",
      "list": "リスト",
      "category-image": "カテゴリー画像",
      "pay-over-usage-cost": "超過利用料金を支払う",
      "over-usage-count": "超過利用回数",
      "over-usage-cost": "超過利用料金",
      "x-usages": "{{ x }} 回利用",
      "failed-to-pay-over-usage-cost": "超過利用料金の支払いに失敗しました",
      "manage-your-personal-information-and-account-perferences": "個人情報とアカウント設定を管理します。",
      "manage-your-organization-contact-information-and-address": "組織の連絡先情報と住所を管理します。",
      "manage-your-billing-overview": "請求詳細、プラン、お支払い情報を確認します。",
      "manage-your-plan-and-usage": "現在のプランと利用制限を確認します。",
      "manage-your-measurement-dimensions": "サイズチャート全体で使用する採寸寸法を管理します。",
      "dimension-translations": "ストアフロント向け翻訳",
      "dimension-translations-description": "サポートされている各ストアフロント言語で購入者に表示するラベルを入力します。空欄にするとデフォルト名が使用されます。",
      "default-dimension-name": "デフォルトの寸法名",
      "dimension-name-description": "ダッシュボード全体で使用され、翻訳が提供されていない場合のストアフロントでのフォールバックとしても使用されます。",
      "storefront-label": "ストアフロント表示名",
      "naming": "名前",
      "affecting-data": "影響を受けるデータ",
      "first-name-is-required": "名は必須です",
      "last-name-is-required": "姓は必須です",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "最新情報、限定オファー、注目のアップデートを受け取るために登録済みです。",
      "contact-information": "連絡先情報",
      "contact-name": "連絡先名",
      "contact-name-is-required": "連絡先名は必須です!",
      "contact-email": "連絡先メールアドレス",
      "contact-email-is-required": "連絡先メールアドレスは必須です!",
      "contact-email-is-invalid": "連絡先メールアドレスが無効です!",
      "company-organization-name": "会社名/組織名",
      "company-organization-name-is-required": "会社名/組織名は必須です",
      "street-address": "住所",
      "street-address-is-required": "住所は必須です!",
      "street-address-2": "住所2",
      "city": "市区町村",
      "city-is-required": "市区町村は必須です!",
      "state-province-region": "都道府県/州/地域",
      "state-province-region-is-required": "都道府県/州/地域は必須です!",
      "country": "国",
      "country-is-required": "国は必須です!",
      "postal-zip-code": "郵便番号",
      "postal-zip-code-is-required": "郵便番号は必須です!",
      "themes": "テーマ",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "アプリの見た目をカスタマイズしましょう!ブランドを最もよく表す色を選んでください",
      "sunset-ember": "サンセットエンバー",
      "classic-noir": "クラシックノワール",
      "system-background-colour": "システム背景色",
      "customise-your-button": "ボタンをカスタマイズ",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "ボタンのテキスト、色、スタイルをブランドに合わせてカスタマイズします。",
      "what-should-the-button-say": "ボタンにどのようなテキストを表示しますか?",
      "label-button-is-required": "ボタンラベルは必須です!",
      "text-colour": "テキストの色",
      "text-colour-is-required": "テキストの色は必須です!",
      "please-input-valid-hex-color-code": "有効な16進カラーコードを入力してください",
      "background-color": "背景色",
      "background-colour-is-required": "背景色は必須です!",
      "font-size-in-px": "フォントサイズ (px)",
      "font-size-in-px-is-required": "フォントサイズ (px) は必須です!",
      "border-radius": "境界線の角丸",
      "border-radius-is-required": "境界線の角丸は必須です!",
      "successfully-updated-button-style": "ボタンスタイルを正常に更新しました",
      "font-family": "フォントファミリー",
      "customise-your-font": "フォントをカスタマイズ",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "サイズチャート全体のフォントを更新して、店舗の雰囲気に合わせましょう。",
      "select-a-font-from-the-list-bellow": "以下のリストからフォントを選択してください。",
      "search-font": "フォントを検索...",
      "fetching-fonts": "フォントを取得中...",
      "showing-x-fonts": "{{ x }} 件のフォントを表示中",
      "sort-by-x": "{{ x }} で並び替え",
      "most-popular": "最も人気",
      "here-how-it-will-look-on-your-shop": "ショップでの見え方はこちらです",
      "it-ll-updated-across-all-your-chart-displays": "すべてのチャート表示で更新されます。",
      "update-font-across-all-size-charts": "すべてのサイズチャートのフォントを更新",
      "choose-a-font-to-match-your-store-style": "店舗のスタイルに合うフォントを選択してください",
      "apply-font": "フォントを適用",
      "font-applied-successfully": "フォントを正常に適用しました!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "アップロードした画像を管理・削除します。ファイルの削除は永久的で元に戻せません。",
      "do-you-want-to-delete-image": "画像を削除しますか?",
      "image-deleted-successfully": "画像を正常に削除しました",
      "chart-list": "チャート一覧",
      "delete-x-dimensions": "{{ x }} 件の寸法を削除",
      "view-affecting-data": "影響を受けるデータを表示",
      "no-data-will-be-affected": "影響を受けるデータはありません。",
      "do-you-want-to-delete-selected-dimensions": "選択した寸法を削除しますか?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "これらの寸法を現在使用しているすべての注釈セットとチャートは、注釈とデータが削除されます",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "これらの寸法を現在使用しているすべての注釈セットとチャートは、名前が変更されます",
      "delete-dimension": "寸法を削除",
      "successfully-deleted-dimension": "寸法を正常に削除しました!",
      "successfully-update-dimension": "寸法を正常に更新しました!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "顧客向けの再入荷通知の動作を設定します",
      "activate-back-in-stock-notifications": "再入荷通知を有効にする",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "サイズや商品が売り切れた際に、購入者がアラートを登録できるようにします。在庫が利用可能になると自動的に通知が送信されます。",
      "notification-channels": "通知チャネル",
      "third-party-service": "サードパーティサービス",
      "sms": "SMS",
      "coming-soon": "近日公開",
      "signup-experience-design": "登録エクスペリエンスのデザイン",
      "form-display": "フォーム表示",
      "modal-popup": "モーダルポップアップ",
      "email-template-customisation": "メールテンプレートのカスタマイズ",
      "subject-line": "件名",
      "subject-line-is-required": "件名は必須です",
      "your-size-is-back-in-stock": "サイズが再入荷しました 🎉",
      "email-body": "メール本文",
      "inventory-threshold-setting": "在庫しきい値の設定",
      "notify-shoppers-when-inventory-reaches-at-least": "在庫が少なくとも次の数量に達したら購入者に通知",
      "threshold-is-required": "しきい値は必須です",
      "threshold-must-be-greater-than-0": "しきい値は0より大きくする必要があります",
      "units": "個",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "通知をトリガーするために必要な最小在庫レベルを設定します",
      "choose-a-service": "サービスを選択",
      "signing-out": "サインアウト中",
      "signout-of": "サインアウト:",
      "authenticate": "認証",
      "save-settings": "設定を保存",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "{{first_name}} 様、{{product_name}} ({{size_variant}}) が再入荷しました。売り切れる前にお早めにどうぞ!",
      "successfully-updated-notification-back-in-stock": "再入荷通知を正常に更新しました",
      "preferred-language": "優先言語",
      "successfully-updated-your-profile": "プロフィールを正常に更新しました",
      "successfully-updated-mailing-subscription-status": "メール配信登録状況を正常に更新しました!",
      "upgrade-plan": "プランをアップグレード",
      "overview": "概要",
      "billing-cycle": "請求サイクル",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "請求サイクルは {{ x }} の深夜にリセットされ、次回の請求は {{ y }} です",
      "billing-information": "請求情報",
      "update-billing": "請求情報を更新",
      "monthly-total": "月間合計",
      "free-trial-x-days-left": "無料トライアル - 残り {{ x }} 日",
      "cancel-plan": "プランを解約",
      "change-plan": "プランを変更",
      "plan-and-usage": "プランと利用状況",
      "tier-offers-in-use": "利用中の階層オファー",
      "failed-to-cancel-plan": "プランの解約に失敗しました",
      "total-usage": "合計利用量",
      "current-usage-summary": "現在の利用状況の概要",
      "published-charts": "公開チャート",
      "limit-reached": "上限に達しました",
      "plan-details": "プラン詳細",
      "current-plan": "現在のプラン",
      "select-a-reason": "理由を選択",
      "please-provide-your-reason": "理由をご入力ください",
      "chart-preferences": "チャート設定",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "テンプレートから新しいチャートを作成する際の寸法選択をスキップ",
      "border-color": "境界線の色",
      "border-color-is-required": "境界線の色は必須です!",
      "list-of-charts-using-this-image": "この画像を使用しているチャート一覧",
      "successfully-update-your-profile": "プロフィールを正常に更新しました"
    },
    "analytic": {
      "failed-to-load-statistics": "統計データの読み込みに失敗しました",
      "total-chart-views": "チャート閲覧数",
      "total-add-to-cart": "カート追加数",
      "traffic-by-location": "地域別トラフィック",
      "desktop": "デスクトップ",
      "mobile": "モバイル",
      "size-recommendations": {
        "failed-to-load": "サイズ推奨の分析データの読み込みに失敗しました",
        "total-suggestions-title": "提案回数",
        "conversion-title": "コンバージョン",
        "customers-proceeded": "提案を受け入れて手続きした顧客数",
        "of-x-suggestions": "{{count}} 件の提案中",
        "most-suggested-title": "最も提案された商品とバリエーション",
        "suggestions-count": "{{count}} 件の提案",
        "most-common-profile-title": "最も一般的なプロフィール",
        "average-profile-title": "平均プロフィール",
        "gender": "性別",
        "age-group": "年齢層",
        "height": "身長",
        "weight": "体重",
        "size-recommended": "推奨サイズ",
        "graph-suggestions": "提案",
        "graph-proceed": "手続き",
        "source-all": "すべて",
        "source-chart": "サイズチャート",
        "source-table-chart": "テーブルチャート"
      },
      "chart-views": {
        "failed-to-load": "チャート閲覧数の読み込みに失敗しました",
        "device-types": "デバイスタイプ",
        "most-viewed-chart": "最も閲覧されたチャート",
        "most-viewed-product": "最も閲覧された商品",
        "views-count": "{{ count }} 回の閲覧",
        "view-at": "閲覧日時",
        "location": "場所",
        "graph-label": "閲覧数"
      },
      "add-to-cart": {
        "failed-to-load": "カート追加分析の読み込みに失敗しました",
        "estimated-revenue": "影響を受けた推定金額",
        "conversion-title": "チャート閲覧 → カート追加のコンバージョン",
        "most": "最多カート追加",
        "adds-count": "{{count}} 回のカート追加",
        "added-at": "追加日時",
        "graph-label": "カート追加",
        "views-dataset-label": "閲覧数",
        "add-to-cart-dataset-label": "カートに追加"
      },
      "stock-notifications": {
        "failed-to-load": "在庫通知分析の読み込みに失敗しました",
        "failed-to-load-table": "在庫通知テーブルの読み込みに失敗しました",
        "total-subscriptions": "登録数",
        "total-notifications-sent": "送信済み通知数",
        "delivery-rate": "配信率",
        "opened-of-notified": "{{ opened }} 開封 / {{ notified }} 通知済み",
        "most-subscribed": "最多登録",
        "subscriptions-count": "{{ count }} 件の登録",
        "latest-subscribed": "最新の登録",
        "subscribed-at": "登録日時: {{ date }}",
        "longest-waiting": "再入荷を最も長く待っている",
        "waiting-days": "待機日数: {{ days }} 日",
        "waiting-since": "({{ date }} から)",
        "subscriptions": "登録",
        "notifications-sent": "送信済み通知",
        "opened": "開封済み",
        "at": "日時",
        "graph-label": "登録"
      },
      "paid-gate": {
        "unlock-message": "高度な分析機能をアンロックして、全データを確認しより良い意思決定を行いましょう。",
        "upgrade": "アップグレード",
        "failed-to-fetch-plans": "プランの取得に失敗しました"
      },
      "buy-now": {
        "failed-to-load": "今すぐ購入の分析データの読み込みに失敗しました",
        "total": "今すぐ購入",
        "estimated-revenue": "影響を受けた推定金額",
        "conversion-title": "チャート閲覧 → 今すぐ購入のコンバージョン",
        "most": "「今すぐ購入」で最も購入された商品",
        "buys-count": "{{count}} 回の今すぐ購入",
        "graph-label": "今すぐ購入",
        "views-dataset-label": "閲覧数",
        "buy-now-dataset-label": "今すぐ購入",
        "clicked-at": "クリック日時"
      },
      "overview": {
        "funnel-title": "チャート閲覧のその後",
        "no-views-title": "この期間のチャート閲覧はありません",
        "no-views-hint": "サイズチャートは、公開して商品に割り当てると商品ページに表示されます。",
        "chart-views-caption": "サイズチャートを開いた買い物客",
        "baseline-caption": "以下はすべてこの閲覧数を基準にしています",
        "of-views": "{{ count }} 件の閲覧のうち",
        "not-in-funnel": "チャート経由の流れとは別"
      },
      "preview": {
        "title": "まだデータがありません — これはプレビューです",
        "message": "以下の数値はサンプルデータです。買い物客がサイズチャートを使い始めると、このページはこのように表示されます。"
      }
    },
    "plans": {
      "popular-plan": "人気プラン",
      "try-now": "今すぐ試す",
      "activated": "有効化済み",
      "contact-sales": "営業に問い合わせる",
      "try-free-for-1-month": "1か月間無料でお試し",
      "activate": "有効化",
      "what-included": "含まれる内容は?",
      "choose-the-plan-that-fits-your-business-needs": "ビジネスニーズに合ったプランを選択してください",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "始めたばかりの方でも、堅牢なサイズソリューションをお探しの方でも、あなたに合ったプランをご用意しています。",
      "monthly": "月払い",
      "annually": "年払い",
      "compare-plan-features": "プラン機能を比較",
      "compare-all-plan-features": "すべてのプラン機能を比較",
      "feature-usages": "利用回数",
      "feature-analytics": "分析",
      "feature-support": "サポート",
      "feature-integration": "連携",
      "feature-branding": "ブランディング",
      "feature-api-access": "APIアクセス",
      "feature-stock-notifications": "在庫通知",
      "feature-published-conversion-charts": "公開コンバージョンチャート",
      "feature-advanced-variant-mapping": "バリアントの高度なマッピング",
      "failed-to-fetch-plans": "プランの取得に失敗しました",
      "failed-to-activate-plan": "プランの有効化に失敗しました",
      "contact": {
        "title": "営業に問い合わせる",
        "subtitle": "ストアとご要望についてお聞かせください。担当チームからメールでご連絡します。",
        "message-placeholder": "どのようなお手伝いができますか？",
        "send": "メッセージを送信",
        "success": "ありがとうございます。メッセージを送信しました。担当チームより折り返しご連絡します。",
        "first-name-required": "名は必須です",
        "last-name-required": "姓は必須です",
        "email-required": "メールアドレスは必須です",
        "email-invalid": "メールアドレスが無効です",
        "message-required": "メッセージは必須です"
      },
      "invite": {
        "title": "サブスクリプションの手続きを完了",
        "your-plan": "ご利用プラン",
        "order-summary": "ご注文内容",
        "billed-every-30-days": "30日ごとに請求",
        "billed-yearly": "年払いで請求",
        "free-trial": "{{days}}日間の無料トライアル",
        "due-today": "本日のお支払い",
        "then-every-30-days": "その後は30日ごとに{{price}} USD",
        "then-yearly": "その後は年間{{price}} USD",
        "continue": "承認に進む",
        "shopify-note": "お支払いはShopify経由です。次の画面で請求を承認してください。",
        "switching-note": "承認すると現在のプランが置き換えられます。残り期間分のクレジットはShopifyが適用します。",
        "already-on-plan": "このプランをご利用中です",
        "unavailable-title": "この招待は現在ご利用いただけません",
        "unavailable-body": "リンクの有効期限が切れている可能性があります。送信者にお問い合わせいただくか、すべてのストア向けのプランをご覧ください。",
        "see-plans": "プランを見る",
        "failed-title": "このプランを読み込めませんでした",
        "failed-body": "接続を確認して、ページを再読み込みしてください。"
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "サインインしてください",
        "email-is-required": "メールアドレスは必須です",
        "invalid-email-address": "無効なメールアドレスです",
        "password-is-required": "パスワードは必須です",
        "sign-in": "サインイン",
        "reset-password": "パスワードをリセット",
        "generic-error": "処理中にエラーが発生しました!後でもう一度お試しください。"
      }
    },
    "admin": {
      "reports": {
        "title": "レポート",
        "chart-views": {
          "title": "チャート閲覧数",
          "description": "購入者がサイズチャートを開いた回数を、全店舗にわたってグローバルに確認できます。",
          "failed-to-load": "チャート閲覧数レポートの読み込みに失敗しました",
          "total-views": "チャート閲覧数",
          "most-viewed-chart": "最も閲覧されたチャート",
          "most-viewed-product": "最も閲覧された商品",
          "views-count": "{{ count }} 回の閲覧",
          "traffic-by-location": "地域別トラフィック",
          "device-types": "デバイスタイプ",
          "desktop": "デスクトップ",
          "mobile": "モバイル",
          "top-stores": "トップストア",
          "no-top-stores": "まだ店舗データがありません",
          "graph-label": "閲覧数",
          "view-at": "閲覧日時",
          "location": "場所"
        },
        "add-to-cart": {
          "title": "カートに追加",
          "description": "サイズチャートがカート追加イベントに与える影響を、全店舗にわたってグローバルに確認できます。",
          "failed-to-load": "カート追加レポートの読み込みに失敗しました",
          "total-add-to-cart": "カート追加数",
          "conversion-title": "チャート閲覧 → カート追加のコンバージョン",
          "most": "最多カート追加",
          "adds-count": "{{ count }} 回のカート追加",
          "top-stores": "トップストア",
          "no-top-stores": "まだ店舗データがありません",
          "graph-label": "カート追加",
          "views-dataset-label": "閲覧数",
          "add-to-cart-dataset-label": "カートに追加",
          "added-at": "追加日時"
        },
        "buy-now": {
          "title": "今すぐ購入",
          "description": "サイズチャートが今すぐ購入イベントに与える影響を、全店舗にわたってグローバルに確認できます。",
          "failed-to-load": "今すぐ購入レポートの読み込みに失敗しました",
          "total-buy-now": "今すぐ購入",
          "conversion-title": "チャート閲覧 → 今すぐ購入のコンバージョン",
          "most": "「今すぐ購入」で最も購入された商品",
          "buys-count": "{{ count }} 回の今すぐ購入",
          "top-stores": "トップストア",
          "no-top-stores": "まだ店舗データがありません",
          "graph-label": "今すぐ購入",
          "views-dataset-label": "閲覧数",
          "buy-now-dataset-label": "今すぐ購入",
          "clicked-at": "クリック日時"
        },
        "conversion-funnel": {
          "title": "テーブルチャート変換",
          "description": "テーブルチャートをサイズチャートに変換する際に、店舗運営者が離脱する場所を、全店舗にわたってグローバルに確認できます。",
          "failed-to-load": "テーブルチャート変換レポートの読み込みに失敗しました",
          "total-runs": "開始された変換数",
          "runs-breakdown": "{{ converted }} 件変換済み · {{ handedOver }} 件引き継ぎ済み",
          "conversion-title": "開始 → 変換",
          "handover-rate": "{{ rate }}% が商品の引き継ぎまで進みました",
          "handover-gap-title": "変換済み、未引き継ぎ",
          "of-converted-runs": "変換された試行のうち",
          "handover-gap-description": "引き継ぎは数日後に行われることがあるため、これらの一部は放棄されたのではなく、まだ保留中です。",
          "funnel-title": "コンバージョンファネル",
          "funnel-note": "専用の引き継ぎステップは現在トリガーされなくなりました — バナーが引き継ぎ完了の手段となっているため、この件数はステップコンバージョンではなく引き継ぎの合計として読み取ってください。",
          "no-funnel": "この期間の変換試行はありません",
          "drop-off": "離脱",
          "runs-dataset-label": "試行",
          "drop-offs-title": "試行が終了する箇所",
          "drop-offs-description": "各試行が最後に行ったこと。バナー経由で記録される引き継ぎ完了で終わる試行は正常に完了しています。",
          "no-drop-offs": "この期間の変換試行はありません",
          "dwell-title": "離脱までの時間",
          "dwell-description": "店舗運営者がステップを放棄した場合のみ記録され、確認前にレビューを読んだ時間も含まれます。",
          "no-dwell": "この期間の時間データはありません",
          "step": "ステップ",
          "samples": "サンプル数",
          "median": "中央値",
          "p90": "P90",
          "top-stores": "トップストア",
          "no-top-stores": "まだ店舗データがありません",
          "graph-label": "開始された変換",
          "started-at": "開始日時",
          "duration": "所要時間",
          "last-step": "最終ステップ",
          "outcome": "結果",
          "steps": {
            "entry": "ダイアログを開いた",
            "category": "カテゴリー",
            "mapping": "マッピング",
            "summary": "レビュー",
            "convert": "変換",
            "handover": "引き継ぎ",
            "banner": "バナー"
          },
          "actions": {
            "viewed": "閲覧済み",
            "completed": "完了",
            "skipped": "スキップ済み",
            "back": "戻った",
            "abandoned": "放棄",
            "failed": "失敗",
            "customize_clicked": "カスタマイズがクリックされた",
            "dismissed": "却下"
          },
          "outcomes": {
            "handed-over": "引き継ぎ済み",
            "converted": "変換のみ",
            "failed": "失敗",
            "abandoned": "放棄済み",
            "in-progress": "進行中"
          }
        }
      },
      "delete-category": "カテゴリーを削除",
      "do-you-want-to-delete-selected-categories": "選択したカテゴリーを削除しますか?",
      "global-categories-are-shared-by-every-store": "グローバルカテゴリーはすべての店舗で共有されています — 1つ削除するとすべてに影響します。この操作は元に戻せません。",
      "successfully-deleted-category": "カテゴリーを正常に削除しました",
      "average-cost-per-recommendation": "推奨あたりの平均コスト",
      "failed-to-load-recommendations-average-cost": "推奨の平均コストの読み込みに失敗しました",
      "most-expensive-extract": "最も高額な抽出",
      "most-expensive-recommendation": "最も高額な推奨",
      "total-recommendation-cost": "推奨コスト合計",
      "total-size-recommendation": "サイズ推奨",
      "total-sheet-extract": "シート抽出",
      "new-category": "新しいカテゴリー",
      "category-created-unlisted-hint": "カテゴリーは非公開で作成されました。店舗に公開する前に画像と寸法を追加してください。",
      "category-created-successfully": "カテゴリーを正常に作成しました!",
      "category-search-placeholder": "画像名、店舗名...",
      "dimension-search-placeholder": "寸法名、店舗名...",
      "category-not-found": "カテゴリーが見つかりません",
      "sub-categories-variants": "サブカテゴリー/バリエーション:",
      "add-sub-category-variant": "サブカテゴリー/バリエーションを追加:",
      "from-existing": "既存のものから",
      "create-a-new": "新規作成",
      "sub-category-removed": "サブカテゴリーを削除しました!",
      "remove-sub-category": "サブカテゴリーを削除",
      "remove-sub-category-confirm": "このカテゴリーから {{ x }} を削除しますか?トップレベルのカテゴリーとして引き続き利用可能です。",
      "update-category": "カテゴリーを更新",
      "published-category-hint": "公開されたカテゴリーはすべての店舗に表示されます。非公開のカテゴリーは非表示のままです。",
      "category-updated-successfully": "カテゴリーを正常に更新しました!",
      "uninstalled": "アンインストール済み",
      "inactive": "非アクティブ",
      "install-at": "インストール日",
      "total-chart-views": "チャート閲覧数",
      "chart-view-at": "チャート閲覧日時",
      "store-id": "店舗ID",
      "successfully-deleted-clients": "クライアントを正常に削除しました!",
      "session-replay": "セッションリプレイ",
      "watch-on-amplitude": "Amplitudeで見る",
      "shopify-app": "Shopifyアプリ",
      "shops-online-store": "店舗のオンラインストア",
      "no-more-events-to-load": "読み込むイベントはこれ以上ありません!",
      "failed-to-fetch-events": "イベントの取得に失敗しました!",
      "info": "情報",
      "store-info": "店舗情報",
      "days-ago": "{{ x }} 日前",
      "contact-email": "連絡先メールアドレス",
      "store-url": "店舗URL",
      "activities": "アクティビティ",
      "insights": "インサイト",
      "subscriptions": "登録",
      "failed-to-fetch-client-info": "クライアント情報の取得に失敗しました!",
      "failed-to-load-add-to-cart-analytics": "カート追加分析の読み込みに失敗しました",
      "failed-to-load-buy-now-analytics": "今すぐ購入の分析データの読み込みに失敗しました",
      "failed-to-load-chart-views": "チャート閲覧数の読み込みに失敗しました",
      "failed-to-load-size-recommendations-analytics": "サイズ推奨の分析データの読み込みに失敗しました",
      "failed-to-load-stock-notifications-analytics": "在庫通知分析の読み込みに失敗しました",
      "failed-to-load-stock-notifications-table": "在庫通知テーブルの読み込みに失敗しました",
      "chart-views": "チャート閲覧数",
      "add-to-cart": "カートに追加",
      "buy-now": "今すぐ購入",
      "size-recommendations": "サイズ推奨",
      "stock-notifications": "在庫通知",
      "change-details": "詳細を変更",
      "plan-subscription-details": "プラン登録の詳細",
      "ai-size-recommendation-limit": "AIサイズ推奨の上限",
      "ai-size-recommendation-limit-required": "AIサイズ推奨の上限は必須です!",
      "minimum-limit-is-0": "最小上限は0です!",
      "unlimited": "無制限",
      "chart-limit-drafts-hint": "公開済みのチャートのみがカウントされます。下書きは無制限です。",
      "chart-limit-required": "チャートの上限は必須です！",
      "chart-limit-whole-number": "上限は整数で入力してください！",
      "stock-notification-limit": "在庫通知の上限",
      "stock-notification-limit-required": "在庫通知の上限は必須です!",
      "published-size-chart-limit": "公開サイズチャートの上限",
      "published-table-chart-limit": "公開テーブルチャートの上限",
      "analytic": "分析",
      "full-suite": "フルスイート",
      "select-a-subscription-plan": "登録プランを選択",
      "failed-to-fetch-plans": "プランの取得に失敗しました!",
      "new-plan": "新しいプラン",
      "failed-to-assign-plan-subscription-to-client": "クライアントへのプラン登録の割り当てに失敗しました!",
      "ai-size-recommendation": "AIサイズ推奨",
      "stock-notification": "在庫通知",
      "published-size-charts": "公開サイズチャート",
      "published-table-charts": "公開テーブルチャート",
      "analytic-access": "分析アクセス",
      "activated-at": "有効化日",
      "usages": "利用回数",
      "failed-to-fetch-client-plan-subscription": "クライアントのプラン登録の取得に失敗しました!",
      "advanced-variant-mapping": "高度なバリエーションマッピング",
      "advanced-variant-mapping-description": "チャートは割り当てられたすべての商品で独自のサイズを使い、「カートに追加」は対応する商品バリエーションを選びます。オフの場合、チャートのサイズは各商品のバリエーション名と完全に一致する必要があります。",
      "advanced-variant-mapping-counts": "チャート {{ total }} 件 · 高度なバリエーションマッピング {{ x }} 件",
      "advanced-variant-mapping-drift": "{{ x }} 件のチャートがこの設定と一致していません。",
      "advanced-variant-mapping-repair": "修復",
      "turn-on-advanced-variant-mapping": "高度なバリエーションマッピングをオンにしますか?",
      "turn-off-advanced-variant-mapping": "高度なバリエーションマッピングをオフにしますか?",
      "advanced-variant-mapping-on-body": "このクライアントの {{ x }} 件のチャートすべてがすぐに切り替わり、新しいチャートにも適用されます。採寸値は変更されず、いつでもオフに戻せます。",
      "advanced-variant-mapping-off-body": "このクライアントの {{ x }} 件のチャートすべてが、バリエーション名の完全一致に戻ります。オンの間にサイズ名を変更したチャート(例: 「Blue / S」を「S」に)は、バリエーション名が一致しなくなった商品で採寸値が空になります。",
      "turn-on": "オンにする",
      "turn-off": "オフにする",
      "failed-to-fetch-advanced-variant-mapping": "高度なバリエーションマッピングの取得に失敗しました!",
      "failed-to-update-advanced-variant-mapping": "高度なバリエーションマッピングの更新に失敗しました!",
      "plan-used-as-free-trial": "新規登録クライアントの無料トライアルとして使用されるプラン",
      "x-usages": "{{ x }} 回利用",
      "successfully-updated-configuration-value": "設定値を正常に更新しました",
      "only-authorized-personnel-hint": "アプリケーションのグローバル設定へのアクセスと変更は、認可された担当者のみに許可されています!",
      "password-is-required": "パスワードは必須です",
      "authorize": "承認",
      "1-month": "1か月",
      "3-months": "3か月",
      "6-months": "6か月",
      "1-year": "1年",
      "failed-to-load-costs": "コストの読み込みに失敗しました",
      "failed-to-load-total-recommendations": "推奨合計数の読み込みに失敗しました",
      "archived": "アーカイブ済み",
      "billing-interval": "請求間隔",
      "plan-information": "プラン情報",
      "name-is-required": "名前は必須です!",
      "features": "機能",
      "stock-notification-recommendation-limit": "在庫通知推奨の上限",
      "popular": "人気",
      "allow-trial": "トライアルを許可",
      "interval": "間隔",
      "interval-is-required": "間隔は必須です!",
      "price-is-required": "価格は必須です!",
      "minimum-price-is-0": "最低価格は0です!",
      "discounted-from": "割引前価格",
      "description": "説明",
      "description-is-required": "説明は必須です!",
      "selling-points": "セールスポイント",
      "selling-point-x": "セールスポイント {{ x }}",
      "selling-point-is-required": "セールスポイントは必須です!",
      "analytic-is-required": "分析は必須です!",
      "support": "サポート",
      "support-is-required": "サポートは必須です!",
      "status-is-required": "ステータスは必須です!",
      "manage-preset-dimensions": "プリセットの寸法、検出用同義語、翻訳を管理します。",
      "detection-synonyms": "検出用同義語",
      "add-synonym-placeholder": "同義語を入力してEnterキーを押してください",
      "translations": "翻訳",
      "missing-translation": "翻訳が未設定です",
      "new-dimension": "新しい寸法",
      "edit-dimension": "寸法を編集",
      "delete-preset-dimension": "プリセット寸法を削除",
      "do-you-want-to-delete-this-preset-dimension": "「{{ name }}」を削除しますか?",
      "preset-dimensions-are-shared-by-every-store": "プリセット寸法はすべての店舗で共有されています — 1つ削除すると、それを使用しているすべてのカテゴリーから削除されます。この操作は元に戻せません。",
      "successfully-created-dimension": "寸法を正常に作成しました!",
      "successfully-updated-dimension": "寸法を正常に更新しました!",
      "successfully-deleted-dimension": "寸法を正常に削除しました!",
      "ai-provider-for-file-imports": "ファイルインポートのAIプロバイダー",
      "no-api-key-configured-in-this-environment": "この環境ではAPIキーが設定されていません",
      "ai-provider-saved-applies-to-new-imports": "AIプロバイダーを保存しました。新しいインポートに適用されます。実行中のインポートは元のプロバイダーを使い続けます。",
      "ai-provider-for-size-recommendations": "サイズ推奨のAIプロバイダー",
      "ai-provider-saved-applies-to-next-recommendation": "AIプロバイダーを保存しました。次のサイズ推奨から適用されます。",
      "size-recommendation-provider-hint": "購入者向けのAIサイズ推奨に使われます。ファイルインポートとは別の設定です。",
      "ai-measurement-import": "AIによる採寸データのインポート",
      "name-admin-only": "名前（管理者のみ）",
      "name-admin-only-hint": "アプリはこの名前で Free プランと Enterprise プランを識別します。これらの名前は変更しないでください。",
      "display-name": "表示名",
      "display-name-hint": "プランページ、請求ページ、Shopify の請求で販売者に表示されます。空欄の場合は名前が使われます。",
      "display-name-too-long": "表示名は最大 40 文字です！",
      "availability": "提供期間",
      "available-from-utc": "提供開始（UTC）",
      "available-from-hint": "空欄の場合、有効になり次第提供されます。",
      "expires-at-utc": "終了日時（UTC）",
      "expires-at-required": "終了日時を設定してください！",
      "window-order": "提供開始は終了より前にしてください！",
      "your-time": "あなたの時刻: {{time}}",
      "availability-always": "常に提供",
      "availability-scheduled": "予定: まだ提供されていません",
      "availability-live": "提供中",
      "availability-ended": "終了: 提供されていません",
      "promo-plan": "キャンペーンプラン",
      "replaces-plan": "置き換えるプラン",
      "replaces-plan-none": "なし（通常プラン）",
      "replaces-plan-hint": "このプランの提供中は、置き換えるプランの代わりにこのプランが販売者に表示されます。",
      "campaign": "キャンペーン",
      "campaign-required": "このキャンペーンプランのキャンペーンを選択してください！",
      "merchants-see": "販売者に表示される内容",
      "replaces-x": "{{x}} を置き換え",
      "archiving-hint": "アーカイブすると新規の登録者にのみ非表示になります。現在の登録者はそのまま利用できます。",
      "duplicate-as-promo-plan": "キャンペーンプランとして複製",
      "help-articles": {
        "topic": "トピック",
        "all-topics": "すべてのトピック",
        "topics": {
          "getting-started": "はじめに",
          "size-charts": "サイズチャート",
          "table-charts": "テーブルチャート",
          "assigning-products": "商品への割り当て",
          "storefront-display": "ストアでの表示",
          "chart-import": "チャートのインポート",
          "size-recommendations": "サイズのおすすめ",
          "plans-billing": "プランと請求",
          "troubleshooting": "トラブルシューティング"
        },
        "new-article": "新しいヘルプ記事",
        "slug": "スラッグ",
        "slug-hint": "ヘルプセンターでの記事のアドレス: /help/your-slug。変更すると、古いアドレスへのリンクが使えなくなります。",
        "slug-invalid": "小文字の英字、数字、単一のハイフンを使用してください。",
        "slug-taken": "このスラッグは別の記事で使用されています。",
        "title-is-required": "タイトルは必須です",
        "summary": "概要",
        "summary-hint": "1行で。サポートアシスタントは概要をもとに記事を選びます。",
        "summary-is-required": "概要は必須です",
        "order": "順序",
        "body-hint": "Markdown。他の記事へのリンクは [テキスト](/help/記事のスラッグ) で書きます。",
        "insert-image": "画像を挿入",
        "image-upload-failed": "画像をアップロードできませんでした。",
        "view-on-help-centre": "ヘルプセンターで表示",
        "broken-links": "公開しましたが、次のリンクは存在しないか未公開の記事を指しています:",
        "article-saved": "記事を保存しました",
        "article-published": "記事を公開しました",
        "article-unpublished": "記事を非公開にしました",
        "article-deleted": "記事を削除しました",
        "delete-article": "記事を削除",
        "delete-article-prompt": "「{{title}}」を削除しますか？ヘルプセンターとサポートアシスタントからすぐに消えます。",
        "load-failed": "記事を読み込めませんでした。",
        "export": "エクスポート",
        "import": "インポート",
        "export-failed": "記事をエクスポートできませんでした。",
        "import-title": "ヘルプ記事をインポート",
        "import-checking": "ファイルを確認しています…",
        "import-preview": "{{file}} により {{created}} 件の記事が作成され、{{updated}} 件が更新されます（画像 {{images}} 件）。ファイルにない記事は変更されません。",
        "import-invalid": "このファイルはインポートできません:",
        "imported": "インポート完了: 作成 {{created}} 件、更新 {{updated}} 件。"
      },
      "invite-only": "招待限定",
      "invite-only-hint": "プランページには表示されません。リンクを知っている人は誰でも登録できます。プラン作成後は変更できません。",
      "invite-only-price-required": "招待限定プランには0より大きい価格が必要です",
      "copy-invite-link": "招待リンクをコピー",
      "invite-link-copied": "招待リンクをコピーしました",
      "invite-link-copy-failed": "招待リンクをコピーできませんでした"
    }
  },
  "search": {
    "no-result-found": "結果が見つかりませんでした!",
    "type": {
      "product": "商品",
      "variant": "バリエーション",
      "client": "クライアント"
    },
    "show-less": "表示を減らす",
    "show-full": "すべて表示",
    "search-x-by-full-name": "{{ x }} をフルネームで検索",
    "load-more...": "さらに読み込む..."
  },
  "privacy-policy": "プライバシーポリシー",
  "contact-us": "お問い合わせ",
  "notification": {
    "notification": "通知",
    "mark-all-as-read": "すべて既読にする",
    "compose": "通知を作成",
    "title-required": "タイトルは必須です!",
    "message-required": "メッセージは必須です!",
    "sent-to-all-clients": "すべてのクライアントに通知を送信しました"
  },
  "table": {
    "sort": "並び替え",
    "sort-by": "並び替え基準",
    "oldest-first": "古い順",
    "newest-first": "新しい順",
    "a-z": "A→Z",
    "z-a": "Z→A",
    "lowest-first": "低い順",
    "highest-first": "高い順",
    "no-data-found": "データが見つかりません"
  },
  "grading": {
    "grading-configuration": "グレーディング設定",
    "base-size": "基準サイズ",
    "enter-your-grading-allowances": "グレーディングの許容値を入力してください",
    "base": "基準"
  },
  "chart": {
    "image-nav-previous": "前の画像",
    "image-nav-next": "次の画像",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "画像を追加",
    "image-add-slot-formats": "対応形式: .png、.jpeg、.jpg",
    "image-cap-reached": "このカテゴリの画像数が上限に達しました。",
    "image-upload-failed": "画像をアップロードできませんでした。もう一度お試しください。",
    "image-svg-not-accepted": "ここではSVGファイルは使用できません。",
    "image-delete": "画像を削除",
    "image-move-left": "画像を左に移動",
    "image-move-right": "画像を右に移動",
    "image-delete-confirm-title": "この画像を削除しますか?",
    "image-delete-confirm-body": "この画像は完全に削除され、復元できません。",
    "image-delete-confirm-cancel": "キャンセル",
    "image-delete-confirm-action": "画像を削除",
    "image-delete-last-tooltip": "カテゴリには少なくとも1枚の画像が必要です。",
    "image-customize-first-tooltip": "画像を管理するには、まずこのカテゴリをカスタマイズしてください。",
    "image-delete-failed": "画像を削除できませんでした。もう一度お試しください。",
    "image-reorder-failed": "画像を並べ替えられませんでした。もう一度お試しください。",
    "do-you-want-to-delete-this-chart": "このチャートを削除しますか?",
    "unnamed-chart": "名称未設定のチャート",
    "get-size-chart-permalink": "サイズチャートのパーマリンクを取得",
    "chart-external-link-is-copied-to-clipboard": "チャートの外部リンクがクリップボードにコピーされました",
    "failed-to-duplicate-chart": "チャートの複製に失敗しました",
    "failed-to-create-chart": "チャートの作成に失敗しました",
    "add-new-layout-blocks": "新しいレイアウトブロックを追加",
    "click-on-these-layout-types-and-add-to-the-size-chart": "これらのレイアウトタイプをクリックしてサイズチャートに追加してください",
    "rename-chart": "チャート名を変更",
    "chart-renamed-successfully": "チャート名を正常に変更しました",
    "failed-to-rename-chart": "チャート名の変更に失敗しました",
    "preview": "プレビュー",
    "model-info": "モデル情報",
    "model-details": "モデルの詳細",
    "help-shoppers-by-showing-the-model-height-and-size": "モデルの身長とサイズを表示して購入者をサポートします",
    "model-name": "モデル名",
    "enter-model-name": "モデル名を入力",
    "model-height": "モデルの身長",
    "please-enter-valid-number": "有効な数値を入力してください",
    "size-worn": "着用サイズ",
    "show-variants-by": "バリエーションの表示基準",
    "add-options-like-size-or-color": "サイズや色などのオプションを追加",
    "select-existing-chart": "既存のチャートを選択",
    "search-charts": "チャート名で検索",
    "no-charts-found": "チャートが見つかりません",
    "search-dimensions": "寸法を検索",
    "no-dimensions-found": "寸法が見つかりません",
    "add-a-new-size-chart": "新しいサイズチャートを追加",
    "this-product-is-using-table-chart": "この商品はテーブルチャートを使用しています",
    "update-your-size-chart": "サイズチャートを更新",
    "create-your-size-chart": "サイズチャートを作成",
    "use-a-template": "テンプレートを使用",
    "use-template-variants": "テンプレートとバリエーションを使用",
    "pick-a-method-to-get-started": "開始方法を選択してください",
    "select-an-existing-chart": "既存のチャートを選択",
    "image-set-annotation-panel": "画像セット注釈パネル",
    "measure-guide": "採寸ガイド...",
    "drag-drop-to-mark-measurement-bubble": "ドラッグ&ドロップして採寸ポイントをマーク",
    "are-you-sure-you-want-to-delete-all-measurements": "すべての寸法を削除してもよろしいですか?",
    "accepts-png-jpeg-jpg-svg": ".png、.jpeg、.jpg、.svgに対応",
    "this-name-will-appear-in": "この名前は次の場所に表示されます:",
    "image-set": "画像セット",
    "added-measurements": "追加済みの寸法",
    "no-measurements-added-yet": "まだ寸法が追加されていません",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "チップをドラッグ&ドロップして、キャンバス上の線を編集します",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "寸法を追加した後、上記の「追加済みの寸法」セクションから画像上にドラッグ&ドロップしてください",
    "across-shoulder-front-rise-belt": "肩幅、前股上、ベルトなど",
    "create-measurement": "寸法を作成",
    "examples-across-shoulder-front-rise-cuff-width": "例:「肩幅」、「前股上」、「袖口幅」",
    "delete-anotation-set": "注釈セットを削除",
    "this-will-remove-all-measurements-from-this-image": "これにより、この画像からすべての寸法が削除されます",
    "measurement-name": "寸法名",
    "size-recommender": "サイズレコメンダー",
    "size-recommender-history": "最近の推奨",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "毎回瞬時に最適なサイズを提案する、購入者専用のパーソナルフィッティングアシスタント",
    "stretch-factor": "伸縮性ファクター",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "生地の伸縮性はどの程度ですか?おおよその見積もりで十分です。不明な場合は10%のままにしておいてください",
    "easing": "ゆとり量",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "ゆとり量とは、衣服を着て動けるように人の身体寸法に加える量のことです。",
    "set-default": "デフォルトに設定",
    "suggested": "提案済み",
    "assign-chart": "チャートを割り当て",
    "your-chart-has-not-been-assigned-to-any-product-yet": "チャートはまだどの商品にも割り当てられていません",
    "assign-your-chart-so-it-will-appear-on-product-pages": "商品ページに表示されるようにチャートを割り当ててください",
    "assign-it-to-a-product": "商品に割り当てる",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "サイズチャートを表示したい商品またはコレクションを選択してください",
    "x-matched-y": "{{ x }} が {{ y }} と一致しました",
    "overwritting-x-products": "({{ x }} 件の商品を上書き)",
    "calculating...": "計算中...",
    "select-product-or-collection": "商品またはコレクションを選択",
    "remove-all": "すべて削除",
    "are-you-sure-you-want-to-remove-all-conditions": "すべての条件を削除してもよろしいですか?",
    "list-of-matched-products": "一致した商品の一覧",
    "give-your-size-chart-a-name": "サイズチャートに名前を付けてください",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "この名前はチャートを整理するために内部でのみ使用されます。顧客には表示されません。",
    "eg-mens-t-shirt-size-chart": "例: メンズTシャツサイズチャート",
    "add-text-block": "テキストブロックを追加",
    "product-image-optional": "商品画像 (任意)",
    "add-layout-block": "レイアウトブロックを追加",
    "move-this-block-up": "このブロックを上に移動",
    "move-this-block-down": "このブロックを下に移動",
    "clear-this-image": "この画像をクリア",
    "align-this-image": "この画像を整列",
    "clear-this-video": "この動画をクリア",
    "apply-grading-to-this-table": "このテーブルにグレーディングを適用",
    "duplicate-this-block-to-below": "このブロックを下に複製",
    "remove-this-block": "このブロックを削除",
    "upload-an-image": "画像をアップロード",
    "browse-to-upload": "参照してアップロード",
    "choose-from-our": "以下から選択",
    "ready-made-templates": "既製テンプレート",
    "select-a-template": "テンプレートを選択",
    "new-row": "新しい行",
    "new-column": "新しい列",
    "add-column-left": "左に列を追加",
    "add-column-right": "右に列を追加",
    "move-left": "左に移動",
    "move-right": "右に移動",
    "freeze": "固定",
    "unfreeze": "固定を解除",
    "delete-column": "列を削除",
    "add-row-above": "上に行を追加",
    "add-row-below": "下に行を追加",
    "move-up": "上に移動",
    "move-down": "下に移動",
    "delete-row": "行を削除",
    "insert-video": "動画を挿入",
    "select-a-video": "動画を選択",
    "paste-a-link-to-a-video-here": "動画へのリンクをここに貼り付けてください",
    "webgl-not-supported": "お使いのブラウザはWebGLに対応していません。Chrome、Firefox、Safariなどの最新のブラウザをご利用の場合は、WebGLサポートを有効にしてください。",
    "table-chart-created": "テーブルチャートを作成しました",
    "name-this-image-set": "この画像セットに名前を付けてください",
    "name-your-import": "インポートに名前を付けてください",
    "table-chart-updated": "テーブルチャートを更新しました",
    "chart-updated": "チャートを更新しました",
    "use-how-to-measure-block": "「採寸方法」ブロックを使用しますか?(任意)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "展開可能なパネルの下にテキストブロックが追加され、顧客向けに採寸方法の詳細を記入できるようになります",
    "newest-5-recommendations-given-to-your-customers": "顧客に提供された最新5件の推奨",
    "size-recommended": "推奨サイズ",
    "view-all-data": "すべてのデータを表示",
    "please-select-a-size-worn": "着用サイズを選択してください",
    "recommended-for-this-garment-add-or-remove-as-needed": "この衣料品用に推奨されています。必要に応じて追加または削除してください",
    "add-more": "さらに追加",
    "add-custom-measurements": "カスタム寸法を追加",
    "skip-this-step-next-time": "次回このステップをスキップ",
    "use-unit-conversion": "単位変換を使用",
    "disabled-by-chart": "チャートにより無効化",
    "disabled-globally-by-settings": "設定によりグローバルに無効化",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "ストアフロントに表示されるすべてのチャートで単位変換トグルを非表示にする",
    "assign-products": "商品を割り当て",
    "select-products-to-assign-to-the-chart": "チャートに割り当てる商品を選択",
    "products-assigned-successfully": "商品を正常に割り当てました",
    "source-table": "元テーブル",
    "root-table": "メインテーブル",
    "table-block": "テーブル",
    "which-axis-holds-the-dimension-data": "どの軸が寸法データを保持していますか?(肩、ウエストなど)",
    "columns": "列",
    "rows": "行",
    "measurement-unit": "測定単位",
    "map-each-line-to-a-dimension": "各行を寸法にマッピング",
    "ignore": "無視",
    "line": "行",
    "the-selected-table-has-no-data-to-map": "選択したテーブルにはマッピングするデータがありません。",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "サイズを提案できるように、テーブルが身体寸法にどのようにマッピングされるか教えてください。",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "AIがサイズを提案するために読み取るテーブルを選択してください。",
    "per-dimension-stretch-and-easing-controls": "寸法ごとの伸縮性・ゆとり量の設定",
    "jump-to-table": "テーブルにジャンプ",
    "scroll-to-the-selected-table": "選択したテーブルにスクロール",
    "this-table-is-used-as-your-size-recommendation-data-source": "このテーブルはサイズ推奨のデータソースとして使用されます",
    "this-table-block-can-not-be-deleted-right-now": "現在このテーブルブロックは削除できません"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "店舗の認証中にエラーが発生しました!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "下のボタンをクリックして再試行してください。問題が解決しない場合は、詳しい手順についてお問い合わせください。",
    "refresh-the-app": "アプリを更新",
    "error-occured": "エラーが発生しました!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Goodchartサイズガイドボタンをストアフロントに追加",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Shopifyと連携していることを検出しました。すべての商品ページにサイズガイドボタンを自動表示するにはアプリの埋め込みを有効にするか、特定の場所に配置するにはアプリブロックを追加してください。お困りの場合は、こちらの<a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">ガイド</a>をご覧ください。",
    "enable-app-embed": "アプリの埋め込みを有効にする",
    "add-app-block": "アプリブロックを追加",
    "your-new-size-chart-is-ready-to-review": "新しいサイズチャートの確認準備ができました",
    "look-around-then-hand-the-conversion-over": "購入者にとってはまだ何も変わっていません — テーブルチャートが引き続き公開されています。寸法とガイドを確認し、問題なければ変換を引き継いでください。",
    "about-your-plan-usage": "プラン利用状況について",
    "measurements-applied": "寸法が適用されました",
    "selection-applied-all-variants": "選択内容がすべてのサイズバリエーションに適用されました。",
    "you-have-reached-x-of-ai-size-recommendations-limit": "現在のプランのAIサイズ推奨の上限の{{ x }}%に達しました。100%を超える利用は標準料金が課金されますのでご注意ください。",
    "you-have-reached-x-of-stock-notification-limit": "現在のプランの在庫通知の上限の{{ x }}%に達しました。",
    "over-usage-cost": "超過利用料金",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "AIサイズ推奨の上限を超えました。サービスの利用を続けるには、超過利用料金をお支払いください。",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "AIサイズ推奨の上限を超えました。この機能の利用を続けるには、超過利用料金をお支払いください。",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} 件のテーブルチャートがスマートサイズチャートにアップグレード可能です"
  },
  "onboarding": {
    "skip-for-now": "今はスキップ",
    "step-x-of-y": "ステップ {{ x }} / {{ y }}",
    "select-the-category-that-best-matches-your-product": "商品に最も合うカテゴリーを選択してください。",
    "apparel": "アパレル",
    "tops": "トップス",
    "pants": "パンツ",
    "dresses": "ドレス",
    "shoes": "シューズ",
    "sneakers": "スニーカー",
    "boots": "ブーツ",
    "sandals": "サンダル",
    "accessories": "アクセサリー",
    "belts": "ベルト",
    "bags": "バッグ",
    "hats": "帽子",
    "other-custom": "その他/カスタム",
    "equipment": "器具",
    "tool": "工具",
    "furniture": "家具",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "任意の商品画像をアップロードして、視覚的に寸法を配置します。アパレル、シューズ、アクセサリーに対応しています。",
    "table-style-chart": "テーブル形式チャート",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "行と列を持つグリッドベースのチャートを作成します。詳細なサイズ仕様に最適です。",
    "your-size-chart-is-ready": "サイズチャートの準備ができました",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "このサイズチャートを店舗のどこに表示するかを決められます。このステップをスキップして、後で商品を割り当てることもできます。",
    "apply-this-chart-to-products-now": "このチャートを今すぐ商品に適用",
    "choose-which-products-should-use-this-size-chart": "このサイズチャートを使用する商品を選択してください。",
    "i-ll-do-this-later": "後で行う",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "チャート設定からいつでも割り当てやマッチングを変更できます。",
    "select-products-to-assign-chart-to": "チャートを割り当てる商品を選択",
    "apply-this-chart-to-all-products": "このチャートをすべての商品に適用します。",
    "select-products-to-apply-this-chart-to": "このチャートを適用する商品を選択してください。",
    "assigning...": "割り当て中...",
    "size-chart-created-successfully": "サイズチャートを正常に作成しました",
    "you-can-assign-products-anytime-from-chart-settings": "チャート設定からいつでも商品を割り当てることができます。",
    "view-chart": "チャートを表示",
    "go-to-dashboard": "ダッシュボードに移動",
    "turn-your-size-chart-into-a-conversion-tool": "サイズチャートをコンバージョンツールに変える",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "購入者が適切なサイズを選べるようにし、返品を減らします。",
    "setup-takes-about-2-minutes": "セットアップには約2分かかります。",
    "choose-how-your-size-chart-looks": "サイズチャートの見た目を選択してください",
    "other-ways-to-create-a-chart": "チャートを作成する他の方法",
    "failed-to-proceed-please-try-again": "続行に失敗しました。もう一度お試しください",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "このチャートはShopifyの商品とバリエーションに接続されており、購入者はチャートを離れることなくサイズを選択し、カートに追加したり今すぐ購入したりできます",
    "add-the-size-guide-button-to-your-storefront": "サイズガイドボタンをストアフロントに追加",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "商品ページにGoodChartサイズガイドボタンをどのように表示するか選択してください。",
    "enable-app-embed": "アプリの埋め込みを有効にする",
    "installed": "インストール済み",
    "automatically-display-the-size-guide-button-on-all-product-pages": "すべての商品ページにサイズガイドボタンを自動的に表示します。",
    "add-app-block-to-product-page": "商品ページにアプリブロックを追加",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "商品ページの特定の場所にボタンを配置しますか?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "商品ページテンプレートの特定の場所にサイズガイドボタンを配置します。",
    "open": "開く",
    "check-button-installation": "ボタンのインストールを確認",
    "checking": "確認中...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "素晴らしい!サイズガイドボタンがストアフロントにインストールされました。",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "まだサイズガイドボタンを検出できませんでした。テーマエディターで変更を保存したことを確認してください。",
    "app-block-installed-on-your-product-page": "商品ページにアプリブロックがインストールされました"
  },
  "common": {
    "updated": "更新済み",
    "name": "名前",
    "avatar": "アバター",
    "category-image": "カテゴリー画像",
    "increase": "増加",
    "created": "作成済み",
    "email": "メールアドレス",
    "password": "パスワード",
    "yes": "はい",
    "no": "いいえ",
    "chart": "チャート",
    "gender": "性別",
    "height": "身長",
    "weight": "体重",
    "age-group": "年齢層",
    "fit-preference": "フィット感の好み",
    "score": "スコア",
    "table-chart": "テーブルチャート",
    "draft": "下書き",
    "active": "有効",
    "products": "商品",
    "none": "なし",
    "cancel": "キャンセル",
    "retry": "再試行",
    "delete": "削除",
    "export": "エクスポート",
    "variant": "バリエーション",
    "variants": "バリエーション",
    "account": "アカウント",
    "personal": "個人情報",
    "appearance": "外観",
    "organization": "組織",
    "information": "情報",
    "first-name": "名",
    "last-name": "姓",
    "save": "保存",
    "pay": "支払う",
    "undo": "元に戻す",
    "redo": "やり直す",
    "newsletter-subscription": "ニュースレター登録",
    "button": "ボタン",
    "colour": "色",
    "default": "デフォルト",
    "white": "白",
    "light-grey": "ライトグレー",
    "soft-beige": "ソフトベージュ",
    "saving...": "保存中...",
    "all-changes-saved": "すべての変更が保存されました",
    "publish": "公開",
    "unpublish": "非公開にする",
    "images": "画像",
    "charts": "チャート",
    "confirm": "確認",
    "dimensions": "寸法",
    "new": "新規",
    "missing": "未設定",
    "editing-x": "{{ x }} を編集中",
    "back-in-stock": "再入荷",
    "product": "商品",
    "grading": "グレーディング",
    "more-actions": "その他の操作",
    "table": "テーブル",
    "measurement": "寸法",
    "close": "閉じる",
    "apply": "適用",
    "duplicate": "複製",
    "add-layout-blocks": "レイアウトブロックを追加",
    "text": "テキスト",
    "image": "画像",
    "video": "動画",
    "new-name": "新しい名前",
    "published": "公開済み",
    "all": "すべて",
    "editing": "編集中",
    "show-more": "もっと見る",
    "loading": "読み込み中",
    "or": "または",
    "browse-files": "ファイルを参照",
    "edit": "編集",
    "customize": "カスタマイズ",
    "clear": "クリア",
    "label": "ラベル",
    "discard-changes": "変更を破棄",
    "uploading": "アップロード中...",
    "preset": "プリセット",
    "custom": "カスタム",
    "manage": "管理",
    "done": "完了",
    "reminder": "リマインダー",
    "collections": "コレクション",
    "all-products": "すべての商品",
    "select": "選択",
    "search": "検索",
    "select-all": "すべて選択",
    "size-chart": "サイズチャート",
    "continue": "続ける",
    "back": "戻る",
    "visual-measurement-builder": "ビジュアル採寸ビルダー",
    "recommend": "推奨する",
    "creating...": "作成中...",
    "syncing": "同期中...",
    "preview": "プレビュー",
    "create": "作成",
    "onboarding": "オンボーディング",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dansk",
    "german": "Deutsch",
    "italian": "Italiano",
    "dutch": "オランダ語",
    "japanese": "日本語",
    "off": "オフ",
    "basic": "ベーシック",
    "AI": "AI",
    "details": "詳細",
    "date": "日付",
    "billing": "請求",
    "settings": "設定",
    "log-out": "ログアウト",
    "plan": "プラン",
    "ai-size-recommendation": "AIサイズ推奨",
    "recommendations": "推奨",
    "features": "機能",
    "stock-notification": "在庫通知",
    "published-size-charts": "公開サイズチャート",
    "published-table-charts": "公開テーブルチャート",
    "unlimited": "無制限",
    "x-of-y": "{{ x }} / {{ y }}",
    "measurements": "寸法",
    "selected": "選択済み",
    "select-product": "商品を選択",
    "price": "価格",
    "title": "タイトル",
    "message": "メッセージ",
    "add": "追加",
    "remove": "削除",
    "cm": "cm",
    "in": "インチ",
    "usd": "USD",
    "return": "戻る",
    "next": "次へ",
    "store": "店舗",
    "type": "タイプ",
    "cost": "コスト",
    "incurred-at": "発生日",
    "search-placeholder": "検索...",
    "more": "もっと見る...",
    "load-more": "さらに読み込む...",
    "status": "ステータス",
    "enabled": "有効",
    "disabled": "無効",
    "total": "合計",
    "un-listed": "非公開",
    "global": "グローバル",
    "store-specific": "店舗固有",
    "ai-measurement-import": "AIによる採寸データのインポート",
    "included": "含まれる",
    "not-included": "含まれない"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "設定を正常に更新しました",
    "failed-to-update-your-preferences": "設定の更新に失敗しました"
  },
  "import": {
    "upload-file": "ファイルをアップロード",
    "sheet-import": {
      "title": "ファイルから寸法をアップロード",
      "dropzone": {
        "title": "ここにファイルをドラッグ&ドロップ",
        "accepted-types": "{{types}} — 一度に1ファイル",
        "browse": "ファイルを選択"
      },
      "hint": "最適な結果を得るには: このサイズチャートのバリエーションと一致するサイズ表記の表を1つ、見出しを1行目または1列目にしてください。写真やスクリーンショットは、鮮明に正面から撮影し、表だけが写るようにトリミングしてください。",
      "example": {
        "caption": "対応しているレイアウトの例:",
        "size": "サイズ",
        "chest": "胸囲 (cm)",
        "waist": "ウエスト (cm)"
      },
      "error": {
        "invalid-type": "このファイル形式には対応していません。次のいずれかをアップロードしてください: {{types}}",
        "heic-unsupported": "HEIC形式(iPhoneの写真形式)には対応していません。写真をJPGまたはPNGで書き出してからアップロードしてください。",
        "file-too-large": "ファイルが大きすぎます。最大サイズは {{maxSizeMb}} MB です。"
      },
      "submit": "アップロードして変更を確認",
      "running": {
        "this-chart": "このサイズチャートのインポートはすでに実行中です。",
        "other-chart": "別のサイズチャートのインポートがすでに実行中です。同時に実行できるインポートは1つだけです。",
        "open-import": "インポートを表示"
      },
      "accepted-files-tooltip": "対応ファイル: {{types}}",
      "button": {
        "importing": "インポート中… {{progress}}%",
        "review": "インポートを確認"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "最適なサイズを見つける",
      "subtitle": "より良いフィット感のためのいくつかの簡単な項目",
      "shopping-for": "お探しの対象",
      "women": "女性",
      "men": "男性",
      "other": "その他",
      "measurements": "採寸",
      "height": "身長",
      "height-required": "身長は必須です",
      "min-height": "最小身長は1です",
      "weight": "体重",
      "weight-required": "体重は必須です",
      "min-weight": "最小体重は1です",
      "preferred-fit": "希望のフィット感"
    },
    "result": {
      "suggested-size": "推奨サイズ:",
      "no-fit": "申し訳ございませんが、現在理想的なサイズがないようです。後日改めてご確認ください。",
      "verdict": "判定:",
      "similar-variants": "類似のバリエーション:",
      "proceed": "このバリエーションで進める",
      "estimate-disclaimer": "(ブランドおよびユーザー情報に基づく推定値であり、結果は異なる場合があります。)"
    },
    "ai": {
      "upgrade-title": "プランをアップグレードしてAIサイズ推奨を利用可能にする",
      "upgrade-description": "毎回顧客に最適なサイズを見つける手助けをする機能です。AIが商品の詳細と顧客の入力を分析し、パーソナライズされたサイズ提案を提供することで、購入者は自信を持って購入でき、返品や交換も減少します。今すぐアップグレードして、この体験を店舗に提供しましょう。",
      "image-alt": "サイズ推奨",
      "upgrade-enable": "今すぐアップグレードして有効化",
      "explore-plans": "他のプランを見る",
      "failed-load-recommendations": "推奨の読み込みに失敗しました",
      "failed-fetch-plans": "プランの取得に失敗しました",
      "form-tab": "フォーム",
      "result-tab": "結果"
    },
    "basic": {
      "measurements-required-title": "まず寸法を追加してください",
      "measurements-required-description": "ベーシックサイズ推奨は、このチャートの寸法をもとに購入者にサイズを提案します。チャートに寸法を追加してから有効にしてください。"
    }
  },
  "chart-limit": {
    "title-size": "公開サイズチャートの上限に達しました",
    "title-table": "公開テーブルチャートの上限に達しました",
    "description-size": "現在のプランで公開できるサイズチャートは{{limit}}件で、すでに{{usage}}件公開されています。このチャートは下書きとして保存されました。さらに公開するにはプランをアップグレードするか、不要になったチャートを非公開にしてください。",
    "description-table": "現在のプランで公開できるテーブルチャートは{{limit}}件で、すでに{{usage}}件公開されています。このチャートは下書きとして保存されました。さらに公開するにはプランをアップグレードするか、不要になったチャートを非公開にしてください。",
    "upgrade-plan": "プランをアップグレード",
    "explore-plans": "プランを見る",
    "failed-fetch-plans": "プランを読み込めませんでした。もう一度お試しください。",
    "image-alt": "チャートのイラスト",
    "onboarding-saved-as-draft": "プランの公開チャート上限に達しているため、チャートは下書きとして保存されました。プランをアップグレードするか、別のチャートを非公開にすると公開できます。"
  },
  "help-centre": "ヘルプセンター",
  "dimension-inputs": {
    "add-measurement": "寸法を追加"
  },
  "variant-editor": {
    "option-name": "オプション名",
    "option-values": "オプション値",
    "option-placeholder": "サイズ / 色 / 素材",
    "add-option": "オプションを追加"
  },
  "dimension": {
    "shoulder": "肩幅",
    "bust": "バスト",
    "waist": "ウエスト",
    "arm": "腕",
    "sleeve": "袖",
    "hip": "ヒップ",
    "crotch": "股上",
    "leg": "脚",
    "thigh": "太もも",
    "length": "着丈",
    "bottom_width": "裾幅",
    "chest": "胸囲",
    "inside_leg": "股下",
    "back_length": "後ろ丈",
    "front_length": "前丈",
    "front_rise": "前股上",
    "back_rise": "後股上",
    "leg_opening": "裾口",
    "overbust": "トップバスト",
    "underbust": "アンダーバスト",
    "groups": {
      "tops": "トップス",
      "bottoms": "ボトムス",
      "generals": "全般"
    }
  },
  "analytic": {
    "range": {
      "1m": "1か月",
      "3m": "3か月",
      "6m": "6か月",
      "1y": "1年"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "このストアではすでに復元が実行中です。完了してからもう一度お試しください。",
    "a-snapshot-is-taken-only-on-days-you-change-something": "スナップショットは、変更があった日にのみ作成されます。",
    "actor": {
      "merchant": "あなた",
      "support": "Goodchart サポート",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "請求、プラン、ログイン、連携中の外部サービスは変更されません。",
    "blocked": {
      "entity-exists": "すでに再作成されています — 代わりに復元してください",
      "entity-missing": "すでに存在しません — 代わりに復元してください",
      "unsupported": "元に戻せません — 代わりに復元してください",
      "value-changed": "その後変更されました — 代わりに復元してください"
    },
    "changes": "変更",
    "discard-unsaved-changes": "未保存の変更を破棄しますか？",
    "dont-ask-again-in-this-session": "このセッションでは今後確認しない",
    "earlier": "それ以前",
    "history": "履歴",
    "history-starts-from-your-first-snapshot": "履歴は最初のスナップショットから始まります",
    "label": {
      "category-created": "カテゴリー「{{name}}」を作成",
      "category-deleted": "カテゴリー「{{name}}」を削除",
      "category-updated": "カテゴリー「{{name}}」を編集",
      "chart-created": "サイズチャート「{{name}}」を作成",
      "chart-deleted": "サイズチャート「{{name}}」を削除",
      "chart-updated": "サイズチャート「{{name}}」を編集",
      "dimension-created": "採寸項目「{{name}}」を作成",
      "dimension-deleted": "採寸項目「{{name}}」を削除",
      "dimension-updated": "採寸項目「{{name}}」を編集",
      "draft-assignment-rules": "割り当てルールを変更",
      "draft-edited": "チャートを編集",
      "draft-guide": "採寸ガイドを編集",
      "draft-labels": "サイズ表記を編集",
      "draft-measurements": "サイズ値を編集",
      "draft-model": "モデルの寸法を変更",
      "draft-publication": "公開状態を変更",
      "draft-renamed": "チャート名を変更",
      "draft-size-recommender": "サイズ推奨を変更",
      "draft-variants": "バリエーションを編集",
      "keyword-created": "キーワード「{{name}}」を作成",
      "keyword-deleted": "キーワード「{{name}}」を削除",
      "keyword-updated": "キーワードを{{count}}件編集",
      "products-assigned": "{{count}}件の商品を割り当て",
      "profile-updated": "ストアプロフィールを更新",
      "store-restored": "ストアを{{date}}に復元",
      "table-chart-created": "テーブル「{{name}}」を作成",
      "table-chart-deleted": "テーブル「{{name}}」を削除",
      "table-chart-updated": "テーブル「{{name}}」を編集"
    },
    "no-changes-since-then": "それ以降の変更はありません。",
    "no-snapshots-yet": "スナップショットはまだありません",
    "nothing-created-since-then-will-be-deleted": "それ以降に作成された項目は削除されません。",
    "plus-x-more": "ほか{{x}}件",
    "reloading-the-dashboard": "ダッシュボードを再読み込みしています…",
    "restore": "復元",
    "restore-confirmation-word": "RESTORE",
    "restore-instead": "代わりに復元する",
    "restore-your-store": "ストアを復元",
    "restoring-your-store-do-not-close-this-window": "ストアを復元しています。このウィンドウを閉じないでください。",
    "since-the-x-snapshot": "{{x}}のスナップショット以降",
    "snapshots": "スナップショット",
    "the-change-was-undone-but-the-page-could-not-refresh": "変更は元に戻りましたが、このページを更新できませんでした。再読み込みしてください。",
    "this-backup-predates-image-protection": "このスナップショットは画像の保護を開始する前のものです。以降に削除された画像は復元できません。",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "商品ページで購入者に表示される内容が数秒以内に変わります。",
    "this-changes-what-shoppers-see-right-away": "この操作は購入者の表示にすぐ反映されます。",
    "this-puts-your-store-back-to-how-it-was-on-x": "ストアを{{x}}の状態に戻します。",
    "this-reverses-x-actions-up-to-and-including-y": "「{{y}}」を含む{{x}}件の操作を元に戻します。",
    "trigger": {
      "daily": "毎日",
      "install": "Goodchart のインストール時",
      "manual": "手動（サポート）",
      "migration": "最初のスナップショット",
      "pre-restore": "復元前",
      "reinstall": "Goodchart の再インストール時"
    },
    "type-x-to-confirm": "確認のため {{x}} と入力してください",
    "undid-x": "「{{x}}」を元に戻しました",
    "undo-a-saved-change": "保存済みの変更を元に戻す",
    "undo-to-here": "ここまで元に戻す",
    "undo-x-saved-y": "「{{x}}」（{{y}}に保存）を元に戻しますか？",
    "unsaved": "未保存",
    "we-could-not-load-your-history": "履歴を読み込めませんでした。",
    "we-could-not-load-your-snapshots": "スナップショットを読み込めませんでした。",
    "we-could-not-restore-your-store": "ストアを復元できませんでした。",
    "we-could-not-work-out-what-would-change": "変更内容を確認できませんでした。",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "先に現在のストアのスナップショットを取得するため、この操作は元に戻せます。",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "ストアに変更があった日ごとにスナップショットを取得します。最初のスナップショットが作成されると、ここに履歴が表示されます。",
    "what-comes-back": "復元されるもの",
    "what-is-lost": "失われるもの",
    "working-out-what-would-change": "変更内容を確認しています…",
    "x-assignments": "割り当て{{x}}件",
    "x-charts": "サイズチャート{{x}}件",
    "x-images-cannot-be-brought-back": "{{x}}件の画像は復元できません。37日以上前に削除されています。",
    "x-images-could-not-be-recovered": "{{x}}件の画像を復元できませんでした。37日以上前に削除されています。",
    "x-items-created-since-then-will-be-deleted": "それ以降に作成された{{x}}件の項目が削除されます。例：",
    "x-items-will-be-recreated": "{{x}}件の項目が復元されます。",
    "x-no-longer-exists-after-the-undo": "元に戻したため「{{x}}」は存在しません。",
    "x-table-charts": "テーブル{{x}}件",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "「{{x}}」に未保存の変更があります。元に戻すと破棄されます。",
    "your-store-has-been-restored": "ストアを復元しました。"
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "ファイルを読み取り中",
        "understanding-table": "表を解析中",
        "matching-measurements": "寸法を照合中",
        "building-chart": "サイズチャートを作成中"
      },
      "reconnecting": "再接続しています。しばらくお待ちください。進行状況は失われていません。",
      "keep-working": "作業を続けられます。準備ができたらお知らせします。",
      "cancel": "インポートをキャンセル",
      "cancel-confirm": {
        "title": "このインポートをキャンセルしますか?",
        "message": "アップロードしたファイルは破棄され、このインポートは再開できません。",
        "keep": "待機を続ける",
        "discard": "インポートをキャンセル"
      },
      "ready": {
        "title": "サイズチャートの確認準備ができました",
        "action": "変更を確認"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "写真がぼやけているか暗すぎて読み取れませんでした。鮮明で明るい写真をお使いください。"
      },
      "no-table-found": {
        "message": "このファイルにサイズ表が見つかりませんでした。"
      },
      "unsupported-layout": {
        "message": "この表のレイアウトにはまだ対応していません。"
      },
      "model-timeout": {
        "message": "時間がかかりすぎました。通常は一時的な問題です。"
      },
      "internal": {
        "message": "サイズチャートのインポート中に、当社側で問題が発生しました。"
      },
      "action": {
        "retry": "再試行",
        "try-another-photo": "別の写真を試す",
        "try-another-file": "別のファイルを試す",
        "other-methods": "他の方法"
      }
    },
    "diff-review": {
      "title": "変更を確認",
      "subtitle": "このサイズチャートに適用しない項目のチェックを外してください。",
      "load-error": "このインポートの変更を読み込めませんでした。",
      "no-changes": "変更された寸法はありません。",
      "grid": {
        "variant": "サイズ",
        "dimension": "寸法",
        "old-value": "現在",
        "new-value": "新規"
      },
      "unmatched-variants": "このサイズチャートと一致しないファイル内のサイズ:",
      "unmapped-dimensions": "寸法に割り当てられなかった列:",
      "apply": {
        "button": "変更を適用 ({{count}})",
        "success": "サイズチャートを更新しました ({{count}} 件の変更を適用)",
        "generic-error": "これらの変更を適用できませんでした。もう一度お試しください。"
      },
      "cancel": {
        "button": "インポートをキャンセル"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "このインポートをキャンセルしますか?",
        "message": "アップロードしたファイルと確認中の変更は破棄されます。このインポートは再開できません。",
        "keep": "確認を続ける",
        "discard": "インポートをキャンセル"
      }
    },
    "page": {
      "title": "寸法をインポート",
      "empty": {
        "title": "このサイズチャートで実行中のインポートはありません",
        "message": "スプレッドシートまたはサイズ表の写真をアップロードして、このサイズチャートの寸法を更新します。"
      }
    },
    "upgrade": {
      "title": "AIで採寸データをインポート",
      "description": "スプレッドシートやサイズ表の写真をアップロードすると、このチャートの採寸データを自動で入力します。AIによる採寸データのインポートは現在のプランに含まれていません。ご利用にはプランをアップグレードしてください。",
      "upgrade-plan": "プランをアップグレード",
      "explore-plans": "プランを見る",
      "failed-fetch-plans": "プランを読み込めませんでした。もう一度お試しください。",
      "image-alt": "サイズ表のイラスト"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "ブラックフライデー",
      "chip": "ブラックフライデー価格",
      "popup": {
        "eyebrow": "ブラックフライデー · サイバーマンデー",
        "headline": "最大 {{percent}}% オフ",
        "subheadline": "Goodchart のプラン",
        "body": "一年で最も忙しい一週間に向けてサイズ表を準備しましょう。わかりやすいサイズ表示で「サイズは合う？」という質問も返品も減らせます。",
        "feature-recommender": "お客様一人ひとりにサイズを提案するAIサイズレコメンド",
        "feature-import": "ファイルや画像からサイズ表を作成するAIインポート",
        "feature-analytics": "お客様のサイズ表の利用状況がわかる分析",
        "cta": "セールを見る",
        "later": "あとで"
      },
      "show-offer": "ブラックフライデーのセールを表示"
    },
    "every-plan": "全プラン {{percent}}% オフ",
    "up-to": "最大 {{percent}}% オフ",
    "switch-to": "${{price}}/{{interval}} に切り替える",
    "switch-from": "現在は {{name}}（${{price}}/{{interval}}）です。同じ機能で {{percent}}% お得になります。",
    "switch-note-monthly": "Shopify で新しい価格を承認すると、今月の残り期間分がクレジットされます。",
    "switch-note-annual": "Shopify で新しい価格を承認すると、{{date}} の更新時から適用されます。",
    "switch-note-annual-undated": "Shopify で新しい価格を承認すると、次回の更新時から適用されます。"
  },
  "agent-chat": {
    "open": "サポートチャットを開く",
    "close": "サポートチャットを閉じる",
    "expand": "チャットを拡大",
    "collapse": "チャットを縮小",
    "title": "Goodchart サポート",
    "history": "会話",
    "back": "会話に戻る",
    "new": "新しい会話",
    "placeholder": "Goodchart について質問する",
    "send": "送信",
    "welcome": "こんにちは！サイズ表の設定、ストアのサイズガイド、プランなど、Goodchart について何でもお気軽にご質問ください。",
    "history-empty": "まだ会話はありません。",
    "unread": "新しい返信",
    "you": "あなた",
    "merchant": "マーチャント",
    "assistant": "Goodchart アシスタント",
    "team": "Goodchart チーム",
    "typing": "入力中…",
    "used-articles": "ヘルプ記事をもとに回答しました",
    "retry": "もう一度試す",
    "activity": {
      "articles": "ヘルプ記事を確認しています…",
      "store": "ストアを確認しています…",
      "code": "Goodchart の動作を確認しています…",
      "team": "Goodchart チームに引き継いでいます…"
    },
    "error": {
      "rate-limited": "メッセージの送信が速すぎます。{{seconds}} 秒後にもう一度お試しください。Goodchart チームが必要な場合は、送信できるようになってから私にお申し付けください。",
      "daily-cap": "本日のメッセージ上限に達しました。明日もう一度お試しください。それでも Goodchart チームが必要な場合は、その際に私にお申し付けください。",
      "disabled": "サポートアシスタントは現在ご利用いただけません。",
      "reply-failed": "返信を受け取れませんでした。",
      "unknown": "問題が発生しました。"
    },
    "placeholder-team": "Goodchart チームへの詳細を追加",
    "unavailable": "サポートアシスタントは現在ご利用いただけないため、新しい質問は受け付けていません。Goodchart チームが対応中の会話は履歴から引き続き開けます。",
    "waiting": {
      "title": "Goodchart チームの返信を待っています。",
      "body": "チームがここで返信し、通知でお知らせします。その間に詳細を追加できます。"
    },
    "starters": {
      "create-chart": "サイズ表を作成するにはどうすればいいですか？",
      "no-chart": "サイズ表がない商品はどれですか？",
      "not-showing": "サイズ表がストアに表示されないのはなぜですか？",
      "charts-left": "あといくつサイズ表を公開できますか？"
    },
    "feedback": {
      "helpful": "役に立った",
      "not-helpful": "役に立たなかった",
      "thanks": "フィードバックありがとうございます。",
      "comment-placeholder": "何が間違っていた、または足りなかったですか？（任意）",
      "send": "送信",
      "skip": "スキップ",
      "rated-up": "「役に立った」と評価",
      "rated-down": "「役に立たなかった」と評価"
    }
  }
}
